var menu_trigger = document.querySelector('.nav__toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body'),
    nav_item = document.querySelectorAll('.nav__link--dropdown'),
    nav_text = menu_trigger.querySelector('.nav__text'),
    skipToNav = document.querySelector('.skip-to-nav');

// Utility: Set nav__text label
function setNavText(isOpen) {
    if (!nav_text) return;
    nav_text.textContent = isOpen ? 'Close' : 'Menu';
}

// Utility: Set aria-expanded attribute
function setAriaExpanded(isExpanded) {
    menu_trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
}

// Utility: Set nav and dropdown link tabindex based on open/close state
function updateNavTabIndexes() {
    var navLinks = nav.querySelectorAll('.nav__link');
    var dropdownLinks = nav.querySelectorAll('.nav__dropdown-link');
    if (nav.classList.contains('nav--active')) {
        navLinks.forEach(function(link) {
            link.setAttribute('tabindex', '0');
        });
        dropdownLinks.forEach(function(link) {
            if (link.closest('.nav__item').classList.contains('nav__item--active')) {
                link.setAttribute('tabindex', '0');
            } else {
                link.setAttribute('tabindex', '-1');
            }
        });
    } else {
        navLinks.forEach(function(link) {
            link.setAttribute('tabindex', '-1');
        });
        dropdownLinks.forEach(function(link) {
            link.setAttribute('tabindex', '-1');
        });
    }
}

// Utility: Remove all active nav items and update tab indexes
function removeActiveNavItems() {
    document.querySelectorAll('.nav__item--active').forEach(function(activeItem) {
        activeItem.classList.remove('nav__item--active');
    });
    updateNavTabIndexes();
}

// Store whether header--scroll was present on page load
var headerHadScrollClass = header.classList.contains('header--scroll');

// Utility: Close nav and clean up
function closeNav() {
    nav.classList.remove('nav--active');
    menu_trigger.classList.remove('nav__toggle--active');
    body.classList.remove('overflow--hidden');
    if (window.scrollY < 5 && !headerHadScrollClass) {
        header.classList.remove('header--scroll');
    }
    removeActiveNavItems();
    setAriaExpanded(false);
    setNavText(false); // Set to "Menu"
    updateNavTabIndexes();
}

// Utility: Toggle nav open/close state
function toggleNav() {
    if (nav.classList.contains('nav--active')) {
        closeNav();
    } else {
        menu_trigger.classList.add('nav__toggle--active');
        nav.classList.add('nav--active');
        body.classList.add('overflow--hidden');
        header.classList.add('header--scroll');
        removeActiveNavItems();
        setAriaExpanded(true);
        setNavText(true); // Set to "Close"
        updateNavTabIndexes();
        nav.focus();
    }
}

// Toggle nav on menu trigger click
menu_trigger.addEventListener('click', toggleNav);

// Nav dropdown: only one active at a time, and update tabindex
nav_item.forEach(function (item) {
    item.addEventListener('click', function(e) {
        removeActiveNavItems();
        this.closest('.nav__item').classList.add('nav__item--active');
        updateNavTabIndexes();
        e.stopPropagation();
    });
    // Open dropdown on Enter or Space
    item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
        }
    });
});

// Close nav when clicking outside
document.addEventListener('click', function(event) {
    if (
        nav.classList.contains('nav--active') &&
        !nav.contains(event.target) &&
        !menu_trigger.contains(event.target)
    ) {
        closeNav();
    }
});

// Close nav on Escape key
window.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && nav.classList.contains('nav--active')) {
        closeNav();
    }
});

// Trap focus within nav when open
function trapNavFocus(e) {
    if (!nav.classList.contains('nav--active')) return;
    // Only trap Tab key
    if (e.key !== 'Tab') return;
    // Get all visible, enabled, focusable elements inside nav
    var focusable = nav.querySelectorAll('.nav__link, .nav__dropdown-link');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
        if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
    } else {
        if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }
}

document.addEventListener('keydown', trapNavFocus);

// Call once on page load to set initial state
updateNavTabIndexes();
